import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  colors: [],
  error: "",
};

export const getColors = createAsyncThunk(
  "color/getColors",
  async (_, thunkApi) => {
    const { rejectedWithValue } = thunkApi;
    try {
      const res = await axios.get("product/api/v1/colors/?page_size=10000");
      // console.log(res.data.results);
      const data = res.data.results.map((color) => ({
        id: color.id,
        name: color.name,
      }));

      return data;
    } catch (err) {
      return rejectedWithValue(err);
    }
  },
);

const colorSlice = createSlice({
  name: "color",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getColors.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getColors.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.colors = action.payload;
    });
    builder.addCase(getColors.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default colorSlice.reducer;
